"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _styles = require("../Menu/styles");
var _styles2 = require("../Menu/MenuHeader/styles");
var _styles3 = require("../Menu/MenuGroup/styles");
var _styles4 = require("../Menu/MenuItem/styles");
var _styles5 = require("../Header/styles");
var _mds = require("../Header/styles/mds");
var _styles6 = require("../Header/Nav/styles");
var _Block = _interopRequireDefault(require("../../../components/Block"));
var _Spacing = _interopRequireDefault(require("../../../components/Spacing"));
var _styles7 = require("./styles");
const getMenuSpacing = theme => {
  switch (theme) {
    case 'mds':
      return 's3';
    case 'prizm':
    case 'prizm-next':
      return 's2';
    default:
      return 's3';
  }
};
const Shimmer = ({
  appconfig,
  hiddenMenu,
  collapsedMenu
}) => {
  const theme = (0, _styledComponents.useTheme)();
  const renderHeaderLeftControls = () => {
    if (theme.name === _constants.THEMES.mds) {
      return _react.default.createElement(_mds.ControlsContainer, null, appconfig.menu && _react.default.createElement(_mds.TogglerContainer, null, _react.default.createElement(_Block.default, {
        $display: "flex",
        $flexDirection: "row",
        $alignItems: "center",
        $justifyContent: "center",
        $height: "100%",
        $width: "100%"
      }, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
        width: 24,
        height: 24
      }))), _react.default.createElement(_mds.LogoContainer, null, _react.default.createElement(_mds.LogoInner, null, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
        height: 32
      }))), (appconfig.headerBasedSitemap || appconfig.menu) && _react.default.createElement(_mds.Switcher, {
        expanded: true
      }, _react.default.createElement(_Block.default, {
        $height: "100%",
        $display: "flex",
        $flexDirection: "row",
        $alignItems: "center"
      }, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
        width: 100,
        height: 24
      }), _react.default.createElement(_styles7.HeaderContentPlaceholder, {
        width: 100,
        height: 24,
        style: {
          marginLeft: '24px'
        }
      }))));
    }
    return appconfig.menu && _react.default.createElement(_styles5.TogglerContainer, {
      collapsed: collapsedMenu
    }, _react.default.createElement(_Block.default, {
      $display: "flex",
      $flexDirection: "row",
      $alignItems: "center",
      $justifyContent: "center",
      $height: "100%",
      $width: "100%"
    }, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
      width: 24,
      height: 24
    })));
  };
  return _react.default.createElement(_styles7.Meta, null, _react.default.createElement(_styles7.Main, null, appconfig.menu && _react.default.createElement(_styles.MenuContainer, {
    hasHeader: appconfig.header,
    hiddenMenu: hiddenMenu,
    collapsed: collapsedMenu
  }, theme.name !== _constants.THEMES.mds && _react.default.createElement(_styles2.MenuHeaderContainer, {
    collapsed: collapsedMenu
  }, _react.default.createElement(_styles2.MenuHeaderInner, {
    collapsed: collapsedMenu
  }, _react.default.createElement(_Block.default, {
    $display: "flex",
    $flexDirection: "row",
    $alignItems: "center",
    $justifyContent: "center",
    $height: "100%",
    $width: "100%"
  }, _react.default.createElement(_styles7.MenuContentPlaceholder, {
    width: 24,
    height: 24
  })), !collapsedMenu && _react.default.createElement(_styles7.MenuContentPlaceholder, {
    width: theme.name === _constants.THEMES.prizmNext ? 168 : 185,
    style: {
      marginLeft: '16px'
    }
  }))), _react.default.createElement(_styles.MenuBodyContainer, null, _react.default.createElement(_styles.MenuBody, null, Array.from(Array(10)).map((_, idx) => _react.default.createElement(_styles3.MenuGroupContainer, {
    key: idx
  }, _react.default.createElement(_styles4.MenuItemContainer, {
    collapsed: collapsedMenu
  }, (theme.name !== _constants.THEMES.mds || collapsedMenu) && _react.default.createElement(_Spacing.default, {
    type: "margin",
    horizontal: {
      general: getMenuSpacing(theme.name)
    }
  }, _react.default.createElement(_styles7.MenuContentPlaceholder, {
    width: 32,
    height: 32
  })), _react.default.createElement(_Spacing.default, {
    type: "padding",
    right: {
      general: getMenuSpacing(theme.name)
    },
    $flex: 1
  }, _react.default.createElement(_styles7.MenuContentPlaceholder, {
    height: theme.name !== _constants.THEMES.mds ? 32 : 23
  }))))))), theme.name !== _constants.THEMES.mds && _react.default.createElement(_styles.MenuFooter, null, _react.default.createElement(_styles.MenuFooterInner, null, _react.default.createElement(_styles.MenuFooterLogo, {
    collapsed: collapsedMenu
  }, _react.default.createElement(_styles7.MenuContentPlaceholder, {
    width: collapsedMenu ? 24 : '100%',
    height: 38
  }))))), _react.default.createElement(_styles7.Container, null, appconfig.header && _react.default.createElement(_styles5.HeaderContainer, null, _react.default.createElement(_styles5.HeaderInner, null, renderHeaderLeftControls(), theme.name !== _constants.THEMES.mds && _react.default.createElement(_styles5.BreadcrumbsArea, null, _react.default.createElement(_Block.default, {
    $display: "flex",
    $flexDirection: "row",
    $alignItems: "center",
    $height: "100%"
  }, _react.default.createElement(_Spacing.default, {
    type: "padding",
    vertical: {
      general: 's2'
    },
    horizontal: {
      general: 's3'
    },
    $width: "56px"
  }, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 32,
    height: 32
  })), _react.default.createElement(_Block.default, null, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 120
  }), _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 16,
    style: {
      margin: '0 8px'
    }
  }), _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 200
  })))), _react.default.createElement(_styles6.Nav, null, _react.default.createElement(_styles6.NavIcon, null, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 32,
    height: 32
  })), _react.default.createElement(_styles6.NavIcon, null, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 32,
    height: 32
  })), _react.default.createElement(_styles6.NavIcon, null, _react.default.createElement(_styles7.HeaderContentPlaceholder, {
    width: 32,
    height: 32
  }))))), _react.default.createElement(_styles7.Content, {
    hiddenMenu: hiddenMenu,
    collapsed: collapsedMenu,
    withoutMenu: !appconfig.menu
  }))));
};
var _default = exports.default = Shimmer;